<span
  data-automation-id="position-indicator"
  aria-live="polite"
  translate="navigation.navigation_interval"
  [translateParams]="{ lower: lower, upper: upper }"
></span>
